import { defaultTheme } from '@asgard/ui-library';

const theme = {
  ...defaultTheme
};

export default theme;
